export const PURCHASE_VAT_RATES_FILTER_KEY = 'purchase_vat_rates'
